import i18n from 'i18n';

export const CHECKS_ONLY = i18n.t('constants.captureTypes.checksOnly');
export const CHECKS_AND_DOCS = i18n.t('constants.captureTypes.checksAndDocs');
export const DOCUMENTS_ONLY = i18n.t('constants.captureTypes.documentsOnly');
export const RETAIL = i18n.t('constants.captureTypes.retail');
